function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n2 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n2 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n2++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var Q = Object.defineProperty;
var X = function X(n, i, e) {
  return i in n ? Q(n, i, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : n[i] = e;
};
var c = function c(n, i, e) {
  return X(n, _typeof(i) != "symbol" ? i + "" : i, e);
};
import { ObservableMixin as v, Collection as $, CKEditorError as u, insertToPriorityArray as Z, setDataInElement as G, Config as V, parseBase64EncodedObject as ee, toArray as te, crc32 as ie, releaseDate as ne, uid as U, logError as se, Locale as oe, EmitterMixin as re, KeystrokeHandler as ae, global as K, env as E } from "../../../../../@ckeditor_ckeditor5-utils@45.1.0/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { Model as le, DataController as ce, StylesProcessor as ue, EditingController as de, Conversion as he } from "../../../../../@ckeditor_ckeditor5-engine@45.1.0/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { EditorWatchdog as fe, ContextWatchdog as ge } from "../../../../../@ckeditor_ckeditor5-watchdog@45.1.0/node_modules/@ckeditor/ckeditor5-watchdog/dist/index.js";
import { isFunction as z } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/predicate/isFunction.js";
import { get as me } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/get.js";
import { set as ye } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/set.js"; /**
                                                                                                                * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                */
var Me = /*#__PURE__*/function (_v) {
  function Me(e) {
    var _this;
    _classCallCheck(this, Me);
    _this = _callSuper(this, Me);
    c(_this, "editor");
    c(_this, "_disableStack", new Set());
    _this.editor = e, _this.set("isEnabled", !0);
    return _this;
  }
  _inherits(Me, _v);
  return _createClass(Me, [{
    key: "forceDisabled",
    value: function forceDisabled(e) {
      this._disableStack.add(e), this._disableStack.size == 1 && (this.on("set:isEnabled", B, {
        priority: "highest"
      }), this.isEnabled = !1);
    }
  }, {
    key: "clearForceDisabled",
    value: function clearForceDisabled(e) {
      this._disableStack.delete(e), this._disableStack.size == 0 && (this.off("set:isEnabled", B), this.isEnabled = !0);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
  }], [{
    key: "isContextPlugin",
    get: function get() {
      return !1;
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !1;
    }
  }, {
    key: "isPremiumPlugin",
    get: function get() {
      return !1;
    }
  }]);
}(v());
function B(n) {
  n.return = !1, n.stop();
}
var pe = /*#__PURE__*/function (_v2) {
  function pe(e) {
    var _this2;
    _classCallCheck(this, pe);
    _this2 = _callSuper(this, pe);
    c(_this2, "editor");
    c(_this2, "_isEnabledBasedOnSelection");
    c(_this2, "_affectsData");
    c(_this2, "_disableStack");
    _this2.editor = e, _this2.set("value", void 0), _this2.set("isEnabled", !1), _this2._affectsData = !0, _this2._isEnabledBasedOnSelection = !0, _this2._disableStack = new Set(), _this2.decorate("execute"), _this2.listenTo(_this2.editor.model.document, "change", function () {
      _this2.refresh();
    }), _this2.listenTo(e, "change:isReadOnly", function () {
      _this2.refresh();
    }), _this2.on("set:isEnabled", function (t) {
      if (!_this2.affectsData) return;
      var o = e.model.document.selection,
        h = !(o.getFirstPosition().root.rootName == "$graveyard") && e.model.canEditAt(o);
      (e.isReadOnly || _this2._isEnabledBasedOnSelection && !h) && (t.return = !1, t.stop());
    }, {
      priority: "highest"
    }), _this2.on("execute", function (t) {
      _this2.isEnabled || t.stop();
    }, {
      priority: "high"
    });
    return _this2;
  }
  _inherits(pe, _v2);
  return _createClass(pe, [{
    key: "affectsData",
    get: function get() {
      return this._affectsData;
    },
    set: function set(e) {
      this._affectsData = e;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.isEnabled = !0;
    }
  }, {
    key: "forceDisabled",
    value: function forceDisabled(e) {
      this._disableStack.add(e), this._disableStack.size == 1 && (this.on("set:isEnabled", W, {
        priority: "highest"
      }), this.isEnabled = !1);
    }
  }, {
    key: "clearForceDisabled",
    value: function clearForceDisabled(e) {
      this._disableStack.delete(e), this._disableStack.size == 0 && (this.off("set:isEnabled", W), this.refresh());
    }
  }, {
    key: "execute",
    value: function execute() {}
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
  }]);
}(v());
function W(n) {
  n.return = !1, n.stop();
}
var Ue = /*#__PURE__*/function (_pe) {
  function Ue() {
    var _this3;
    _classCallCheck(this, Ue);
    _this3 = _callSuper(this, Ue, arguments);
    c(_this3, "_childCommandsDefinitions", []);
    return _this3;
  }
  _inherits(Ue, _pe);
  return _createClass(Ue, [{
    key: "refresh",
    value: function refresh() {}
  }, {
    key: "execute",
    value: function execute() {
      var t = this._getFirstEnabledCommand();
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return !!t && t.execute(e);
    }
  }, {
    key: "registerChildCommand",
    value: function registerChildCommand(e) {
      var _this4 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Z(this._childCommandsDefinitions, {
        command: e,
        priority: t.priority || "normal"
      }), e.on("change:isEnabled", function () {
        return _this4._checkEnabled();
      }), this._checkEnabled();
    }
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      this.isEnabled = !!this._getFirstEnabledCommand();
    }
  }, {
    key: "_getFirstEnabledCommand",
    value: function _getFirstEnabledCommand() {
      var e = this._childCommandsDefinitions.find(function (_ref) {
        var t = _ref.command;
        return t.isEnabled;
      });
      return e && e.command;
    }
  }]);
}(pe);
var Y = /*#__PURE__*/function (_re) {
  function Y(e) {
    var _this5;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    _classCallCheck(this, Y);
    _this5 = _callSuper(this, Y);
    c(_this5, "_context");
    c(_this5, "_plugins", new Map());
    c(_this5, "_availablePlugins");
    c(_this5, "_contextPlugins");
    _this5._context = e, _this5._availablePlugins = new Map();
    var _iterator = _createForOfIteratorHelper(t),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var a = _step.value;
        a.pluginName && _this5._availablePlugins.set(a.pluginName, a);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    _this5._contextPlugins = new Map();
    var _iterator2 = _createForOfIteratorHelper(o),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _ref2 = _step2.value;
        var _ref3 = _slicedToArray(_ref2, 2);
        var _a = _ref3[0];
        var h = _ref3[1];
        _this5._contextPlugins.set(_a, h), _this5._contextPlugins.set(h, _a), _a.pluginName && _this5._availablePlugins.set(_a.pluginName, _a);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return _this5;
  }
  _inherits(Y, _re);
  return _createClass(Y, [{
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      var _iterator3, _step3, e;
      return _regeneratorRuntime().wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _iterator3 = _createForOfIteratorHelper(this._plugins);
            _context.prev = 1;
            _iterator3.s();
          case 3:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 11;
              break;
            }
            e = _step3.value;
            _context.t0 = typeof e[0] == "function";
            if (!_context.t0) {
              _context.next = 9;
              break;
            }
            _context.next = 9;
            return e;
          case 9:
            _context.next = 3;
            break;
          case 11:
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t1 = _context["catch"](1);
            _iterator3.e(_context.t1);
          case 16:
            _context.prev = 16;
            _iterator3.f();
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, value, this, [[1, 13, 16, 19]]);
    })
  }, {
    key: "get",
    value: function get(e) {
      var t = this._plugins.get(e);
      if (!t) {
        var o = e;
        throw typeof e == "function" && (o = e.pluginName || e.name), new u("plugincollection-plugin-not-loaded", this._context, {
          plugin: o
        });
      }
      return t;
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._plugins.has(e);
    }
  }, {
    key: "init",
    value: function init(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var a = this,
        h = this._context;
      b(e), p(e);
      var y = e.filter(function (s) {
          return !C(s, t);
        }),
        S = _toConsumableArray(P(y));
      I(S, o);
      var k = A(S);
      return D(k, "init").then(function () {
        return D(k, "afterInit");
      }).then(function () {
        return k;
      });
      function _(s) {
        return typeof s == "function";
      }
      function O(s) {
        return _(s) && !!s.isContextPlugin;
      }
      function C(s, d) {
        return d.some(function (r) {
          return r === s || m(s) === r || m(r) === s;
        });
      }
      function m(s) {
        return _(s) ? s.pluginName || s.name : s;
      }
      function b(s) {
        var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
        s.forEach(function (r) {
          _(r) && (d.has(r) || (d.add(r), r.pluginName && !a._availablePlugins.has(r.pluginName) && a._availablePlugins.set(r.pluginName, r), r.requires && b(r.requires, d)));
        });
      }
      function P(s) {
        var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
        return s.map(function (r) {
          return _(r) ? r : a._availablePlugins.get(r);
        }).reduce(function (r, l) {
          return d.has(l) ? r : (d.add(l), l.requires && (p(l.requires, l), P(l.requires, d).forEach(function (f) {
            return r.add(f);
          })), r.add(l));
        }, new Set());
      }
      function p(s) {
        var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        s.map(function (r) {
          return _(r) ? r : a._availablePlugins.get(r) || r;
        }).forEach(function (r) {
          T(r, d), N(r, d), R(r, d);
        });
      }
      function T(s, d) {
        if (!_(s)) throw d ? new u("plugincollection-soft-required", h, {
          missingPlugin: s,
          requiredBy: m(d)
        }) : new u("plugincollection-plugin-not-found", h, {
          plugin: s
        });
      }
      function N(s, d) {
        if (O(d) && !O(s)) throw new u("plugincollection-context-required", h, {
          plugin: m(s),
          requiredBy: m(d)
        });
      }
      function R(s, d) {
        if (d && C(s, t)) throw new u("plugincollection-required", h, {
          plugin: m(s),
          requiredBy: m(d)
        });
      }
      function A(s) {
        return s.map(function (d) {
          var r = a._contextPlugins.get(d);
          return r = r || new d(h), a._add(d, r), r;
        });
      }
      function D(s, d) {
        return s.reduce(function (r, l) {
          return !l[d] || a._contextPlugins.has(l) ? r : r.then(l[d].bind(l));
        }, Promise.resolve());
      }
      function I(s, d) {
        var _iterator4 = _createForOfIteratorHelper(d),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var r = _step4.value;
            if (typeof r != "function") throw new u("plugincollection-replace-plugin-invalid-type", null, {
              pluginItem: r
            });
            var l = r.pluginName;
            if (!l) throw new u("plugincollection-replace-plugin-missing-name", null, {
              pluginItem: r
            });
            if (r.requires && r.requires.length) throw new u("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
              pluginName: l
            });
            var f = a._availablePlugins.get(l);
            if (!f) throw new u("plugincollection-plugin-for-replacing-not-exist", null, {
              pluginName: l
            });
            var w = s.indexOf(f);
            if (w === -1) {
              if (a._contextPlugins.has(f)) return;
              throw new u("plugincollection-plugin-for-replacing-not-loaded", null, {
                pluginName: l
              });
            }
            if (f.requires && f.requires.length) throw new u("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
              pluginName: l
            });
            s.splice(w, 1, r), a._availablePlugins.set(l, r);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var e = [];
      var _iterator5 = _createForOfIteratorHelper(this),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ref4 = _step5.value;
          var _ref5 = _slicedToArray(_ref4, 2);
          var t = _ref5[1];
          typeof t.destroy == "function" && !this._contextPlugins.has(t) && e.push(t.destroy());
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return Promise.all(e);
    }
  }, {
    key: "_add",
    value: function _add(e, t) {
      this._plugins.set(e, t);
      var o = e.pluginName;
      if (o) {
        if (this._plugins.has(o)) throw new u("plugincollection-plugin-name-conflict", null, {
          pluginName: o,
          plugin1: this._plugins.get(o).constructor,
          plugin2: e
        });
        this._plugins.set(o, t);
      }
    }
  }]);
}(re());
var L = /*#__PURE__*/function () {
  function L(i) {
    _classCallCheck(this, L);
    c(this, "config");
    c(this, "plugins");
    c(this, "locale");
    c(this, "t");
    c(this, "editors");
    c(this, "_contextOwner", null);
    var _ref6 = i || {},
      e = _ref6.translations,
      t = _objectWithoutProperties(_ref6, ["translations"]);
    this.config = new V(t, this.constructor.defaultConfig);
    var o = this.constructor.builtinPlugins;
    this.config.define("plugins", o), this.plugins = new Y(this, o);
    var a = this.config.get("language") || {};
    this.locale = new oe({
      uiLanguage: typeof a == "string" ? a : a.ui,
      contentLanguage: this.config.get("language.content"),
      translations: e
    }), this.t = this.locale.t, this.editors = new $();
  }
  return _createClass(L, [{
    key: "initPlugins",
    value: function initPlugins() {
      var i = this.config.get("plugins") || [],
        e = this.config.get("substitutePlugins") || [];
      var _iterator6 = _createForOfIteratorHelper(i.concat(e)),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var t = _step6.value;
          if (typeof t != "function") throw new u("context-initplugins-constructor-only", null, {
            Plugin: t
          });
          if (t.isContextPlugin !== !0) throw new u("context-initplugins-invalid-plugin", null, {
            Plugin: t
          });
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return this.plugins.init(i, [], e);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;
      return Promise.all(Array.from(this.editors, function (i) {
        return i.destroy();
      })).then(function () {
        return _this6.plugins.destroy();
      });
    }
  }, {
    key: "_addEditor",
    value: function _addEditor(i, e) {
      if (this._contextOwner) throw new u("context-addeditor-private-context");
      this.editors.add(i), e && (this._contextOwner = i);
    }
  }, {
    key: "_removeEditor",
    value: function _removeEditor(i) {
      return this.editors.has(i) && this.editors.remove(i), this._contextOwner === i ? this.destroy() : Promise.resolve();
    }
  }, {
    key: "_getEditorConfig",
    value: function _getEditorConfig() {
      var i = {};
      var _iterator7 = _createForOfIteratorHelper(this.config.names()),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var e = _step7.value;
          ["plugins", "removePlugins", "extraPlugins"].includes(e) || (i[e] = this.config.get(e));
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return i;
    }
  }], [{
    key: "create",
    value: function create(i) {
      var _this7 = this;
      return new Promise(function (e) {
        var t = new _this7(i);
        e(t.initPlugins().then(function () {
          return t;
        }));
      });
    }
  }]);
}();
c(L, "defaultConfig"), c(L, "builtinPlugins");
var we = /*#__PURE__*/function (_v3) {
  function we(e) {
    var _this8;
    _classCallCheck(this, we);
    _this8 = _callSuper(this, we);
    c(_this8, "context");
    _this8.context = e;
    return _this8;
  }
  _inherits(we, _v3);
  return _createClass(we, [{
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
  }], [{
    key: "isContextPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !1;
    }
  }, {
    key: "isPremiumPlugin",
    get: function get() {
      return !1;
    }
  }]);
}(v());
var be = /*#__PURE__*/function () {
  function be() {
    _classCallCheck(this, be);
    c(this, "_commands");
    this._commands = new Map();
  }
  return _createClass(be, [{
    key: "add",
    value: function add(i, e) {
      this._commands.set(i, e);
    }
  }, {
    key: "get",
    value: function get(i) {
      return this._commands.get(i);
    }
  }, {
    key: "execute",
    value: function execute(i) {
      var t = this.get(i);
      if (!t) throw new u("commandcollection-command-not-found", this, {
        commandName: i
      });
      for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        e[_key2 - 1] = arguments[_key2];
      }
      return t.execute.apply(t, e);
    }
  }, {
    key: "names",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
      return _regeneratorRuntime().wrap(function names$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.delegateYield(this._commands.keys(), "t0", 1);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, names, this);
    })
  }, {
    key: "commands",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function commands() {
      return _regeneratorRuntime().wrap(function commands$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.delegateYield(this._commands.values(), "t0", 1);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, commands, this);
    })
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._commands[Symbol.iterator]();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator8 = _createForOfIteratorHelper(this.commands()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var i = _step8.value;
          i.destroy();
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }]);
}();
var _e = /*#__PURE__*/function (_ae) {
  function _e(e) {
    var _this9;
    _classCallCheck(this, _e);
    _this9 = _callSuper(this, _e);
    c(_this9, "editor");
    _this9.editor = e;
    return _this9;
  }
  _inherits(_e, _ae);
  return _createClass(_e, [{
    key: "set",
    value: function set(e, t) {
      var _this0 = this;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (typeof t == "string") {
        var a = t;
        t = function t(h, y) {
          _this0.editor.execute(a), y();
        };
      }
      _superPropGet(_e, "set", this, 3)([e, t, o]);
    }
  }]);
}(ae);
var q = "contentEditing",
  j = "common";
var Ee = /*#__PURE__*/function () {
  function Ee(i) {
    _classCallCheck(this, Ee);
    c(this, "keystrokeInfos", new Map());
    c(this, "_editor");
    this._editor = i;
    var e = i.config.get("menuBar.isVisible"),
      t = i.locale.t;
    this.addKeystrokeInfoCategory({
      id: q,
      label: t("Content editing keystrokes"),
      description: t("These keyboard shortcuts allow for quick access to content editing features.")
    });
    var o = [{
      label: t("Close contextual balloons, dropdowns, and dialogs"),
      keystroke: "Esc"
    }, {
      label: t("Open the accessibility help dialog"),
      keystroke: "Alt+0"
    }, {
      label: t("Move focus between form fields (inputs, buttons, etc.)"),
      keystroke: [["Tab"], ["Shift+Tab"]]
    }, {
      label: t("Move focus to the toolbar, navigate between toolbars"),
      keystroke: "Alt+F10",
      mayRequireFn: !0
    }, {
      label: t("Navigate through the toolbar or menu bar"),
      keystroke: [["arrowup"], ["arrowright"], ["arrowdown"], ["arrowleft"]]
    }, {
      label: t("Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content."),
      keystroke: [["Enter"], ["Space"]]
    }];
    e && o.push({
      label: t("Move focus to the menu bar, navigate between menu bars"),
      keystroke: "Alt+F9",
      mayRequireFn: !0
    }), this.addKeystrokeInfoCategory({
      id: "navigation",
      label: t("User interface and content navigation keystrokes"),
      description: t("Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface."),
      groups: [{
        id: "common",
        keystrokes: o
      }]
    });
  }
  return _createClass(Ee, [{
    key: "addKeystrokeInfoCategory",
    value: function addKeystrokeInfoCategory(_ref7) {
      var _this1 = this;
      var i = _ref7.id,
        e = _ref7.label,
        t = _ref7.description,
        o = _ref7.groups;
      this.keystrokeInfos.set(i, {
        id: i,
        label: e,
        description: t,
        groups: new Map()
      }), this.addKeystrokeInfoGroup({
        categoryId: i,
        id: j
      }), o && o.forEach(function (a) {
        _this1.addKeystrokeInfoGroup(_objectSpread({
          categoryId: i
        }, a));
      });
    }
  }, {
    key: "addKeystrokeInfoGroup",
    value: function addKeystrokeInfoGroup(_ref8) {
      var _ref8$categoryId = _ref8.categoryId,
        i = _ref8$categoryId === void 0 ? q : _ref8$categoryId,
        e = _ref8.id,
        t = _ref8.label,
        o = _ref8.keystrokes;
      var a = this.keystrokeInfos.get(i);
      if (!a) throw new u("accessibility-unknown-keystroke-info-category", this._editor, {
        groupId: e,
        categoryId: i
      });
      a.groups.set(e, {
        id: e,
        label: t,
        keystrokes: o || []
      });
    }
  }, {
    key: "addKeystrokeInfos",
    value: function addKeystrokeInfos(_ref9) {
      var _o$groups$get$keystro;
      var _ref9$categoryId = _ref9.categoryId,
        i = _ref9$categoryId === void 0 ? q : _ref9$categoryId,
        _ref9$groupId = _ref9.groupId,
        e = _ref9$groupId === void 0 ? j : _ref9$groupId,
        t = _ref9.keystrokes;
      if (!this.keystrokeInfos.has(i)) throw new u("accessibility-unknown-keystroke-info-category", this._editor, {
        categoryId: i,
        keystrokes: t
      });
      var o = this.keystrokeInfos.get(i);
      if (!o.groups.has(e)) throw new u("accessibility-unknown-keystroke-info-group", this._editor, {
        groupId: e,
        categoryId: i,
        keystrokes: t
      });
      (_o$groups$get$keystro = o.groups.get(e).keystrokes).push.apply(_o$groups$get$keystro, _toConsumableArray(t));
    }
  }]);
}();
function ke(n) {
  return {
    sessionId: Oe(),
    pageSessionId: Ce(),
    hostname: window.location.hostname,
    version: globalThis.CKEDITOR_VERSION,
    type: Pe(n),
    plugins: xe(n.plugins),
    distribution: ve(),
    env: Se(),
    integration: Object.create(null),
    menuBar: {
      isVisible: !!n.config.get("menuBar.isVisible")
    },
    language: {
      ui: n.locale.uiLanguage,
      content: n.locale.contentLanguage
    },
    toolbar: {
      main: M(n.config.get("toolbar")),
      block: M(n.config.get("blockToolbar")),
      balloon: M(n.config.get("balloonToolbar"))
    }
  };
}
function Pe(n) {
  return Object.getPrototypeOf(n).constructor.editorName;
}
function xe(n) {
  return Array.from(n).filter(function (_ref0) {
    var _ref1 = _slicedToArray(_ref0, 1),
      i = _ref1[0];
    return !!i.pluginName;
  }).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 1),
      i = _ref11[0];
    var e = i.pluginName,
      t = i.isContextPlugin,
      o = i.isOfficialPlugin,
      a = i.isPremiumPlugin;
    return {
      isContext: !!t,
      isOfficial: !!o,
      isPremium: !!a,
      name: e
    };
  });
}
function M(n) {
  if (!n) return;
  var i = Array.isArray(n) ? {
      items: n
    } : n,
    e = a(i.items || []);
  return {
    isMultiline: e.includes("-"),
    shouldNotGroupWhenFull: !!i.shouldNotGroupWhenFull,
    items: o(e)
  };
  function o(h) {
    return h.filter(function (y) {
      return y !== "|" && y !== "-";
    });
  }
  function a(h) {
    return h.flatMap(function (y) {
      return typeof y == "string" ? [y] : a(y.items);
    });
  }
}
function ve() {
  return {
    channel: window[Symbol.for("cke distribution")] || "sh"
  };
}
function Se() {
  var n = "unknown",
    i = "unknown";
  return E.isMac ? n = "mac" : E.isWindows ? n = "windows" : E.isiOS ? n = "ios" : E.isAndroid && (n = "android"), E.isGecko ? i = "gecko" : E.isBlink ? i = "blink" : E.isSafari && (i = "safari"), {
    os: n,
    browser: i
  };
}
function Oe() {
  return localStorage.getItem("__ckeditor-session-id") || localStorage.setItem("__ckeditor-session-id", U()), localStorage.getItem("__ckeditor-session-id");
}
function Ce() {
  return K.window.CKEDITOR_PAGE_SESSION_ID = K.window.CKEDITOR_PAGE_SESSION_ID || U(), K.window.CKEDITOR_PAGE_SESSION_ID;
}
var x = /*#__PURE__*/function (_v4) {
  function x() {
    var _this10;
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, x);
    _this10 = _callSuper(this, x);
    c(_this10, "accessibility");
    c(_this10, "commands");
    c(_this10, "config");
    c(_this10, "conversion");
    c(_this10, "data");
    c(_this10, "editing");
    c(_this10, "locale");
    c(_this10, "model");
    c(_this10, "plugins");
    c(_this10, "keystrokes");
    c(_this10, "t");
    c(_this10, "_context");
    c(_this10, "_readOnlyLocks");
    if ("sanitizeHtml" in e) throw new u("editor-config-sanitizehtml-not-supported");
    var t = _this10.constructor,
      _ref12 = t.defaultConfig || {},
      o = _ref12.translations,
      a = _objectWithoutProperties(_ref12, ["translations"]),
      _e$translations = e.translations,
      h = _e$translations === void 0 ? o : _e$translations,
      y = _objectWithoutProperties(e, ["translations"]),
      S = e.language || a.language;
    _this10._context = e.context || new L({
      language: S,
      translations: h
    }), _this10._context._addEditor(_this10, !e.context);
    var k = Array.from(t.builtinPlugins || []);
    _this10.config = new V(y, a), _this10.config.define("plugins", k), _this10.config.define(_this10._context._getEditorConfig()), O(_this10.config), _this10.plugins = new Y(_this10, k, _this10._context.plugins), _this10.locale = _this10._context.locale, _this10.t = _this10.locale.t, _this10._readOnlyLocks = new Set(), _this10.commands = new be(), _this10.set("state", "initializing"), _this10.once("ready", function () {
      return _this10.state = "ready";
    }, {
      priority: "high"
    }), _this10.once("destroy", function () {
      return _this10.state = "destroyed";
    }, {
      priority: "high"
    }), _this10.model = new le(), _this10.on("change:isReadOnly", function () {
      _this10.model.document.isReadOnly = _this10.isReadOnly;
    });
    var _ = new ue();
    _this10.data = new ce(_this10.model, _), _this10.editing = new de(_this10.model, _), _this10.editing.view.document.bind("isReadOnly").to(_this10), _this10.conversion = new he([_this10.editing.downcastDispatcher, _this10.data.downcastDispatcher], _this10.data.upcastDispatcher), _this10.conversion.addAlias("dataDowncast", _this10.data.downcastDispatcher), _this10.conversion.addAlias("editingDowncast", _this10.editing.downcastDispatcher), _this10.keystrokes = new _e(_this10), _this10.keystrokes.listenTo(_this10.editing.view.document), _this10.accessibility = new Ee(_this10), C(_this10);
    function O(m) {
      var b = m.get("licenseKey");
      if (!b && window.CKEDITOR_GLOBAL_LICENSE_KEY && (b = window.CKEDITOR_GLOBAL_LICENSE_KEY, m.set("licenseKey", b)), !b) throw new u("license-key-missing");
    }
    function C(m) {
      var b = m.config.get("licenseKey"),
        P = window[Symbol.for("cke distribution")] || "sh";
      function p(l) {
        m.enableReadOnlyMode(Symbol("invalidLicense")), m._showLicenseError(l);
      }
      function T(l) {
        var f = l.split(".");
        return f.length != 3 ? null : f[1];
      }
      function N(l) {
        return ["exp", "jti", "vc"].every(function (w) {
          return w in l;
        });
      }
      function R(l) {
        return Object.getOwnPropertyNames(l).sort().filter(function (g) {
          return g != "vc" && l[g] != null;
        }).map(function (g) {
          return l[g];
        });
      }
      function A(l) {
        var _URL = new URL(window.location.href),
          f = _URL.hostname;
        if (l.includes(f)) return !0;
        var w = f.split(".");
        return l.filter(function (g) {
          return g.includes("*");
        }).map(function (g) {
          return g.split(".");
        }).filter(function (g) {
          return g.length <= w.length;
        }).map(function (g) {
          return Array(w.length - g.length).fill(g[0] === "*" ? "*" : "").concat(g);
        }).some(function (g) {
          return w.every(function (J, F) {
            return g[F] === J || g[F] === "*";
          });
        });
      }
      function D(l) {
        var f = l[0].toUpperCase() + l.slice(1),
          w = l === "evaluation" ? "an" : "a";
        console.info("%cCKEditor 5 ".concat(f, " License"), "color: #ffffff; background: #743CCD; font-size: 14px; padding: 4px 8px; border-radius: 4px;"), console.warn("\u26A0\uFE0F You are using ".concat(w, " ").concat(l, " license of CKEditor 5").concat(l === "trial" ? " which is for evaluation purposes only" : "", ". For production usage, please obtain a production license at https://portal.ckeditor.com/"));
      }
      if (b == "GPL") {
        P == "cloud" && p("distributionChannel");
        return;
      }
      var I = T(b);
      if (!I) {
        p("invalid");
        return;
      }
      var s = ee(I);
      if (!s) {
        p("invalid");
        return;
      }
      if (!N(s)) {
        p("invalid");
        return;
      }
      if (s.distributionChannel && !te(s.distributionChannel).includes(P)) {
        p("distributionChannel");
        return;
      }
      if (ie(R(s)) != s.vc.toLowerCase()) {
        p("invalid");
        return;
      }
      if (new Date(s.exp * 1e3) < ne) {
        p("expired");
        return;
      }
      var r = s.licensedHosts;
      if (r && r.length > 0 && !A(r)) {
        p("domainLimit");
        return;
      }
      if (["evaluation", "trial"].includes(s.licenseType) && s.exp * 1e3 < Date.now()) {
        p("expired");
        return;
      }
      if (["development", "evaluation", "trial"].includes(s.licenseType)) {
        var l = s.licenseType;
        window.CKEDITOR_WARNING_SUPPRESSIONS = window.CKEDITOR_WARNING_SUPPRESSIONS || {}, window.CKEDITOR_WARNING_SUPPRESSIONS[l] || (D(l), window.CKEDITOR_WARNING_SUPPRESSIONS[l] = !0);
      }
      if (["evaluation", "trial"].includes(s.licenseType)) {
        var _l = s.licenseType,
          f = setTimeout(function () {
            p("".concat(_l, "Limit"));
          }, 6e5);
        m.on("destroy", function () {
          clearTimeout(f);
        });
      }
      s.usageEndpoint && m.once("ready", function () {
        var l = {
          requestId: U(),
          requestTime: Math.round(Date.now() / 1e3),
          license: b,
          editor: De(m)
        };
        m._sendUsageRequest(s.usageEndpoint, l).then(function (f) {
          var w = f.status,
            g = f.message;
          g && console.warn(g), w != "ok" && p("usageLimit");
        }, function () {
          se("license-key-validation-endpoint-not-reachable", {
            url: s.usageEndpoint
          });
        });
      }, {
        priority: "high"
      });
    }
    return _this10;
  }
  _inherits(x, _v4);
  return _createClass(x, [{
    key: "isReadOnly",
    get: function get() {
      return this._readOnlyLocks.size > 0;
    },
    set: function set(e) {
      throw new u("editor-isreadonly-has-no-setter");
    }
  }, {
    key: "enableReadOnlyMode",
    value: function enableReadOnlyMode(e) {
      if (typeof e != "string" && _typeof(e) != "symbol") throw new u("editor-read-only-lock-id-invalid", null, {
        lockId: e
      });
      this._readOnlyLocks.has(e) || (this._readOnlyLocks.add(e), this._readOnlyLocks.size === 1 && this.fire("change:isReadOnly", "isReadOnly", !0, !1));
    }
  }, {
    key: "disableReadOnlyMode",
    value: function disableReadOnlyMode(e) {
      if (typeof e != "string" && _typeof(e) != "symbol") throw new u("editor-read-only-lock-id-invalid", null, {
        lockId: e
      });
      this._readOnlyLocks.has(e) && (this._readOnlyLocks.delete(e), this._readOnlyLocks.size === 0 && this.fire("change:isReadOnly", "isReadOnly", !1, !0));
    }
  }, {
    key: "setData",
    value: function setData(e) {
      this.data.set(e);
    }
  }, {
    key: "getData",
    value: function getData(e) {
      return this.data.get(e);
    }
  }, {
    key: "initPlugins",
    value: function initPlugins() {
      var e = this.config,
        t = e.get("plugins"),
        o = e.get("removePlugins") || [],
        a = e.get("extraPlugins") || [],
        h = e.get("substitutePlugins") || [];
      return this.plugins.init(t.concat(a), o, h);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this11 = this;
      var e = Promise.resolve();
      return this.state == "initializing" && (e = new Promise(function (t) {
        return _this11.once("ready", t);
      })), e.then(function () {
        _this11.fire("destroy"), _this11.stopListening(), _this11.commands.destroy();
      }).then(function () {
        return _this11.plugins.destroy();
      }).then(function () {
        _this11.model.destroy(), _this11.data.destroy(), _this11.editing.destroy(), _this11.keystrokes.destroy();
      }).then(function () {
        return _this11._context._removeEditor(_this11);
      });
    }
  }, {
    key: "execute",
    value: function execute(e) {
      try {
        var _this$commands;
        for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          t[_key3 - 1] = arguments[_key3];
        }
        return (_this$commands = this.commands).execute.apply(_this$commands, [e].concat(t));
      } catch (o) {
        /* istanbul ignore next -- @preserve */u.rethrowUnexpectedError(o, this);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.editing.view.focus();
    }
  }, {
    key: "_showLicenseError",
    value: function _showLicenseError(e, t) {
      setTimeout(function () {
        if (e == "invalid") throw new u("invalid-license-key");
        if (e == "expired") throw new u("license-key-expired");
        if (e == "domainLimit") throw new u("license-key-domain-limit");
        if (e == "featureNotAllowed") throw new u("license-key-plugin-not-allowed", null, {
          pluginName: t
        });
        if (e == "evaluationLimit") throw new u("license-key-evaluation-limit");
        if (e == "trialLimit") throw new u("license-key-trial-limit");
        if (e == "developmentLimit") throw new u("license-key-development-limit");
        if (e == "usageLimit") throw new u("license-key-usage-limit");
        if (e == "distributionChannel") throw new u("license-key-invalid-distribution-channel");
      }, 0), this._showLicenseError = function () {};
    }
  }, {
    key: "_sendUsageRequest",
    value: function () {
      var _sendUsageRequest2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t) {
        var o, a;
        return _regeneratorRuntime().wrap(function _callee$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              o = new Headers({
                "Content-Type": "application/json"
              });
              _context4.next = 3;
              return fetch(new URL(e), {
                method: "POST",
                headers: o,
                body: JSON.stringify(t)
              });
            case 3:
              a = _context4.sent;
              if (a.ok) {
                _context4.next = 6;
                break;
              }
              throw new Error("HTTP Response: ".concat(a.status));
            case 6:
              return _context4.abrupt("return", a.json());
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee);
      }));
      function _sendUsageRequest(_x, _x2) {
        return _sendUsageRequest2.apply(this, arguments);
      }
      return _sendUsageRequest;
    }()
  }], [{
    key: "editorName",
    get: function get() {
      return "Editor";
    }
  }, {
    key: "create",
    value: function create() {
      throw new Error("This is an abstract method.");
    }
  }]);
}(v());
c(x, "defaultConfig"), c(x, "builtinPlugins"), c(x, "Context", L), c(x, "EditorWatchdog", fe), c(x, "ContextWatchdog", ge);
function De(n) {
  var i = ke(n);
  function e(t, o) {
    if (me(i, t) !== void 0) throw new u("editor-usage-data-path-already-set", {
      path: t
    });
    ye(i, t, o);
  }
  return n.fire("collectUsageData", {
    setUsageData: e
  }), i;
}
function Fe(n) {
  if (!z(n.updateSourceElement)) throw new u("attachtoform-missing-elementapi-interface", n);
  var i = n.sourceElement;
  if (Ie(i) && i.form) {
    var e;
    var t = i.form,
      o = function o() {
        return n.updateSourceElement();
      };
    z(t.submit) && (e = t.submit, t.submit = function () {
      o(), e.apply(t);
    }), t.addEventListener("submit", o), n.on("destroy", function () {
      t.removeEventListener("submit", o), e && (t.submit = e);
    });
  }
}
function Ie(n) {
  return !!n && n.tagName.toLowerCase() === "textarea";
}
function H(n) {
  var i = /*#__PURE__*/function (_n) {
    function i() {
      var _this12;
      _classCallCheck(this, i);
      _this12 = _callSuper(this, i, arguments);
      c(_this12, "sourceElement");
      return _this12;
    }
    _inherits(i, _n);
    return _createClass(i, [{
      key: "updateSourceElement",
      value: function updateSourceElement(o) {
        if (!this.sourceElement) throw new u("editor-missing-sourceelement", this);
        var a = this.config.get("updateSourceElementOnDestroy"),
          h = this.sourceElement instanceof HTMLTextAreaElement;
        if (!a && !h) {
          G(this.sourceElement, "");
          return;
        }
        var y = typeof o == "string" ? o : this.data.get();
        G(this.sourceElement, y);
      }
    }]);
  }(n);
  return i;
}
H.updateSourceElement = H(Object).prototype.updateSourceElement;
var Ge = /*#__PURE__*/function (_we) {
  function Ge() {
    var _this13;
    _classCallCheck(this, Ge);
    _this13 = _callSuper(this, Ge, arguments);
    c(_this13, "_actions");
    return _this13;
  }
  _inherits(Ge, _we);
  return _createClass(Ge, [{
    key: "init",
    value: function init() {
      this.set("hasAny", !1), this._actions = new $({
        idProperty: "_id"
      }), this._actions.delegate("add", "remove").to(this);
    }
  }, {
    key: "add",
    value: function add(e) {
      if (typeof e != "string") throw new u("pendingactions-add-invalid-message", this);
      var t = new (v())();
      return t.set("message", e), this._actions.add(t), this.hasAny = !0, t;
    }
  }, {
    key: "remove",
    value: function remove(e) {
      this._actions.remove(e), this.hasAny = !!this._actions.length;
    }
  }, {
    key: "first",
    get: function get() {
      return this._actions.get(0);
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._actions[Symbol.iterator]();
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "PendingActions";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(we);
export { pe as Command, L as Context, we as ContextPlugin, x as Editor, H as ElementApiMixin, Ue as MultiCommand, Ge as PendingActions, Me as Plugin, Fe as attachToForm };